const API = {
  // 提问
  question: "/aiGateway/ai/chat/messages",
  // 停止响应
  stopGenerating: "./aiGateway/ai/messages/stop/v2",
  // 获取历史会话详情
  getHistoryMessageDetail: "./aiGateway/ai/messages/v2",
  // 获取历史会话列表
  getHistoryMessageList: "./aiGateway/ai/conversations/v2",
  // 删除会话
  deleteMessage: "./aiGateway/ai/conversations/del/v2",

  // 获取开场白
  getPrologue: "./aiGateway/ai/parameters/v2",
  // 语音转文字
  audioToText: "./aiGateway/ai/audioToText",
  // 文字转语音
  TextToAudio: "./aiGateway/ai/textToAudio/v2",
  // 会话顶置  取消顶置
  conversationSetTop: "./aiGateway/ai/conversations/top",
  // 修改会话名称
  conversationRename: "./aiGateway/ai/conversations/rename/v2",
  // 发现列表
  getFindList: "./aiGateway/ai/find/list",
  // 获取问题建议
  getSuggested: "./aiGateway/ai/suggested/v2",
  // 获取今日会话次数
  getConversationCount: "./aiGateway/ai/user/dialog/count",
  // 清除上下文
  cleanConversationText: "./aiGateway/ai/conversations/clean/v2",
  // 添加智能体
  addAgent: "./aiGateway/ai/agent/add/v2",
  // 删除智能体
  deleteAgent: "./aiGateway/ai/agent/del/v2",
  // 获取会话名称
  getConversationName: "./aiGateway/ai/conversation/name/query",
  // 通过ai_app_code查找会话
  findConversation: "./aiGateway/ai/conversations/info/v2",
  // 查询新对话是否配置
  getNewChat: "./aiGateway/ai/query/normal-app",
  // 智能体信息查询
  getAgentInfo: "./aiGateway/ai/query/app-info",

  // 特殊
  // 通过小程序sessionId换取sessionId
  loginS2S: "apps.user.login.s2s",
  // 拿着s2s的sessionId去换authCode
  getAuthCode: "apps.app.extra.ai",
  // 拉码接口
  getQrCode: "apps.user.3rdQRCode",

  // 获取用户session
  getSessionId: "./aiGateway/user/auth",
  // 获取验证码
  getCaptcha: "./aiGateway/user/sms-send",
  // 手机号登录
  SmsLogin: "./aiGateway/user/sms-login",
  // 退出登录
  logout: "./aiGateway/user/logout",
  // 会员信息查询
  getUserVipInfo: "./aiGateway/user/member-info",

  //文件上传
  uploadFile: "./aiGateway/ai/file/upload",

  // 打开关闭自动播放
  switchAutoTTS: "./aiGateway/ai/conversations/tts-switch",
  // 播放语音(自动)
  autoTextToAudio: "./aiGateway/ai/messageToAudio",
  // 查询会话是否开启了自动播放
  getAutoTTSInfo: "./aiGateway/ai/conversations/tts-query",
  // 查询tts token数量
  getTTSLimit: "./aiGateway/ai/conversations/tts-limit",

  //举报类型
  complaintTypes: "./aiGateway/ai/complaint/types",
  //新增举报
  complaintAdd: "./aiGateway/ai/complaint/add",

  // 对话列表 查询AI引导
  getGuides: "./aiGateway/ai/guide/getGuides",
  // 会话详情  获取当前会话额度&inputs参数
  getChatDetail: "./aiGateway/ai/conversations/detail",

  // 游客登录
  guestLogin: "./aiGateway/user/guest-login",
  // 查询是否启用了游客模式
  getSystemInfo: "./aiGateway/ai/system/info",



  // 判断当前游客和登录用户是否可以合并
  isMergeable: "./aiGateway/user/isMergeable",
  // 合并游客用户
  mergeGuest: "./aiGateway/user/merge-guest",
};
export { API };
